import "./src/styles/globalstyles.css"